// extracted by mini-css-extract-plugin
module.exports = {"image-container":"SingleImage_image-container__2Loz9"};